// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9f5fcc10 _cda9498a","headerText":"_194ee4a1"};